import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase-config';

// En desarrollo la solicitud la recibe el servidor local (src/setupProxy.js); en producción, el panel de webs de la EC2.
const SOLICITUD_URL = process.env.REACT_APP_WEBS_SOLICITUD_URL
  || (process.env.NODE_ENV === 'development' ? '/api/solicitud-web' : 'https://editor.lisual.com/webs/api/solicitud');

// Dirección aproximada a partir de las coordenadas de la cámara (OpenStreetMap).
export async function direccionDesdeCoords(lat, lng) {
  if (!lat || !lng) return '';
  try {
    const r = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=es&zoom=18`);
    const j = await r.json(); const a = j.address || {};
    const calle = [a.road, a.house_number].filter(Boolean).join(' ');
    const zona = a.suburb || a.neighbourhood || a.city_district || a.town || a.village || a.city || '';
    const ciudad = a.city || a.town || a.state_district || '';
    return [calle, zona !== ciudad ? zona : '', ciudad, a.state].filter(Boolean).join(', ');
  } catch (e) {
    return '';
  }
}

// Sólo local (npm start con REACT_APP_DATOS_OBRA_UPLOAD_LOCAL=1): los archivos van al servidor de desarrollo
// (POST /api/datos-obra-dev/subir/:feed, carpeta de la PC), nunca a Firebase Storage de producción.
const SUBIDA_LOCAL = process.env.NODE_ENV === 'development' && process.env.REACT_APP_DATOS_OBRA_UPLOAD_LOCAL === '1';
const BASE_LOCAL = (process.env.REACT_APP_DATOS_OBRA_API_URL || '').replace(/\/$/, '');
async function subirLocal(file, carpeta, onProgress) {
  const partes = String(carpeta).split('/');
  const feed = partes[1] || 'sin-feed';
  const r = await fetch(`${BASE_LOCAL}/api/datos-obra-dev/subir/${encodeURIComponent(feed)}?categoria=${encodeURIComponent(partes[partes.length - 1] || 'otros')}&nombre=${encodeURIComponent(file.name)}`, {
    method: 'POST', headers: { 'Content-Type': 'application/octet-stream' }, body: file,
  });
  if (!r.ok) throw new Error(`No se pudo subir ${file.name} al servidor local`);
  if (onProgress) onProgress(file.size);
  return r.json();
}

// Sube un archivo a Firebase Storage y devuelve su link de descarga.
export function subirArchivo(file, carpeta, onProgress) {
  if (SUBIDA_LOCAL && BASE_LOCAL) return subirLocal(file, carpeta, onProgress);
  return new Promise((resolve, reject) => {
    const limpio = file.name.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Za-z0-9._-]+/g, '-');
    const tarea = uploadBytesResumable(ref(storage, `${carpeta}/${Date.now()}-${limpio}`), file, { contentType: file.type || 'application/octet-stream' });
    tarea.on('state_changed', (s) => onProgress && onProgress(s.bytesTransferred), reject, async () => {
      resolve({ nombre: file.name, bytes: file.size, url: await getDownloadURL(tarea.snapshot.ref) });
    });
  });
}

export async function enviarSolicitud(datos) {
  const r = await fetch(SOLICITUD_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(datos) });
  if (!r.ok) throw new Error('No se pudo enviar la solicitud (' + r.status + ')');
  return r.json();
}

export async function estadoSolicitud(feed) {
  try {
    const r = await fetch(`${SOLICITUD_URL}?feed=${encodeURIComponent(feed)}`);
    if (!r.ok) return null;
    const j = await r.json();
    return j && j.id ? j : null;
  } catch (e) {
    return null;
  }
}
